import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useWindowWidth from '../hooks/useWindowWidth';
import { swalSuccess, swalError, swalConfirm } from '../utils/alert';
import './CardList.css';

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/D';
  const date = new Date(dateString);
  date.setDate(date.getDate() + 1);
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

function BankList({ onEdit }) {
  const [banks, setBanks] = useState([]);
  const width = useWindowWidth();

  const fetchBanks = () => {
    api.get('/banks')
      .then(response => {
        setBanks(response.data);
      })
      .catch(error => {
        console.error('Houve um erro ao buscar os bancos!', error);
      });
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  const handleDelete = async (id) => {
    const result = await swalConfirm({ text: 'Tem certeza que deseja excluir este banco?' });
    if (!result.isConfirmed) return;
    try {
      await api.delete(`/banks/${id}`);
      swalSuccess('Banco excluído com sucesso!');
      fetchBanks();
    } catch (error) {
      console.error('Houve um erro ao excluir o banco!', error);
      swalError('Erro ao excluir banco.');
    }
  };

  const renderMobileView = () => (
    <div>
      {banks.map(bank => (
        <div key={bank.id} className="card-list-card" style={{ borderLeft: `4px solid ${bank.color || '#007bff'}` }}>
          <div className="card-list-card-header">
            <h3>{bank.name}</h3>
            <span className="card-list-card-amount">{formatCurrency(bank.initial_balance)}</span>
          </div>
          <div className="card-list-card-body">
            {bank.code && <p><strong>Código:</strong> {bank.code}</p>}
            {bank.agency && <p><strong>Agência:</strong> {bank.agency}</p>}
            {bank.account_number && <p><strong>Conta:</strong> {bank.account_number}</p>}
            {bank.account_type && <p><strong>Tipo:</strong> {bank.account_type}</p>}
            {bank.opening_date && <p><strong>Abertura:</strong> {formatDate(bank.opening_date)}</p>}
            <p><strong>Status:</strong> {bank.status}</p>
            {bank.overdraft_limit > 0 && <p><strong>Cheque Especial:</strong> {formatCurrency(bank.overdraft_limit)}</p>}
          </div>
          <div className="card-list-card-footer">
            <button className="btn btn-warning btn-sm me-2" onClick={() => onEdit(bank)}>Editar</button>
            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(bank.id)}>Excluir</button>
          </div>
        </div>
      ))}
    </div>
  );

  const renderDesktopView = () => (
    <table className="table table-striped table-hover">
      <thead className="thead-dark">
        <tr>
          <th>Nome</th>
          <th>Código</th>
          <th>Agência</th>
          <th>Número da Conta</th>
          <th>Tipo de Conta</th>
          <th>Saldo</th>
          <th>Data de Abertura</th>
          <th>Status</th>
          <th>Cor</th>
          <th>Limite Cheque Especial</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {banks.map(bank => (
          <tr key={bank.id}>
            <td>{bank.name}</td>
            <td>{bank.code}</td>
            <td>{bank.agency}</td>
            <td>{bank.account_number}</td>
            <td>{bank.account_type}</td>
            <td>{formatCurrency(bank.initial_balance)}</td>
            <td>{formatDate(bank.opening_date)}</td>
            <td>{bank.status}</td>
            <td><span style={{ display: 'inline-block', width: 16, height: 16, borderRadius: '50%', backgroundColor: bank.color || '#ccc' }}></span></td>
            <td>{bank.overdraft_limit ? formatCurrency(bank.overdraft_limit) : 'N/D'}</td>
            <td>
              <button className="btn btn-warning btn-sm me-2" onClick={() => onEdit(bank)}>Editar</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(bank.id)}>Excluir</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div>
      <h2>Bancos</h2>
      {width < 768 ? renderMobileView() : renderDesktopView()}
    </div>
  );
}

export default BankList;
